import { render, staticRenderFns } from "./visbg.vue?vue&type=template&id=0aa3d6dd"
import script from "./visbg.vue?vue&type=script&lang=js"
export * from "./visbg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports